import React, { FC } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { ImageDataLike } from 'gatsby-plugin-image';
import { LinkType } from '../../types';
import Typography from '../typography/Typography';
import Image from '../image/Image';
import LinkTo from '../linkTo/LinkTo';

// Interface

export interface PartnerLogoProps {
  image?: ImageDataLike | string;
  link: LinkType;
}

// Styles

const StyledPartnerLogo = styled.div`
  ${({ theme: { space, colors, media } }) => css`
    display: flex;
    flex-direction: column;
    gap: ${space.small};

    @media (min-width: ${media.medium}) {
      flex-direction: row;
      gap: ${space.medium};
      align-items: center;
      justify-content: center;
    }
  `};
`;

// JSX

export const PartnerLogo: FC<PartnerLogoProps> = ({ image, link }) => (
  <StyledPartnerLogo>
    <Typography component="h2" variant="headingXSmall">
      Partnering with
    </Typography>
    <LinkTo to={link?.url} title={link?.label}>
      <Image src={image} alt={link?.label} />
    </LinkTo>
  </StyledPartnerLogo>
);

export default PartnerLogo;
